module.exports = __webpack_public_path__ + "img/orange_016.6b31d90e.png";